import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import * as rawJSONSchemaModuleUrology from '../../schemas/module-urology.json';

class ModuleValueUrology extends ModuleValueUniversal {
  serum_psa_radical_prostatectomy?: number;
  surgical_approach_prostatectomy?: string;
  nerve_sparing_prostatectomy?: string;
  retzius_sparing_prostatectomy?: string;
  follow_up_prostatectomy?: string;
  discharge_date_prostatectomy?: string;
  length_of_stay_prostatectomy?: string;
}

export class SchemaModuleUrology extends SchemaModuleUniversal<ModuleValueUrology> {
  schema: JSONSchema<ModuleValueUrology>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleUrology );
  }

  hook( form: FormComponent ) {
    super.hook( form );

    this.listenValue(
      [ 'discharge_date_prostatectomy', 'date_of_surgery' ],
      this.fieldHandlerDischargeDate( 'length_of_stay_prostatectomy' ).bind( this )
    );

    // If surgical_approach_prostatectomy is selected (any value)
    // then fields nerve_sparing_prostatectomy and retzius_sparing_prostatectomy are required
    // this.listenValue( 'surgical_approach_prostatectomy', ( value: string ) => {
    //   this.schema.properties.nerve_sparing_prostatectomy.required = !value;
    //   this.schema.properties.retzius_sparing_prostatectomy.required = !value;
    // });
  }

  setupValidators() {
    super.setupValidators();

    this.validatorDateComparison( 'discharge_date_prostatectomy', 'date_of_surgery', '>=' );
    this.validatorDateComparison( 'follow_up_prostatectomy', 'date_of_surgery', '>=' );
    this.validatorDateComparison( 'date_of_surgery', 'date_of_birth', '>=' );

    this.addValidator('serum_psa_radical_prostatectomy', (value, formProperty, form) => {
      if (value === null || value === undefined) {
        return []; // Allow empty values
      }
      const regex = /^\d+(\.\d)?$/;
      return regex.test(value) ? [] : [{
        code: 'invalidNumber',
        path: `#/${formProperty.path}`,
        message: 'Serum PSA must be a number with at most one decimal place.'
      }];
    });

  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-urology.ts